// Browser shim for Node's 'fs' module.
// Backed by our in-memory/IndexedDB FileSystem adapter.

import { fileSystem } from '@/adapters/FileSystem';

export function existsSync(p) {
  return fileSystem.existsSync(p);
}

export function statSync(p) {
  return fileSystem.statSync(p);
}

export function readdirSync(prefix) {
  return fileSystem.readdirSync(prefix);
}

export function unlinkSync(p) {
  return fileSystem.unlinkSync(p);
}

// No-op in browser - virtual file system doesn't need explicit directory creation
export function mkdirSync(/* p, options */) {
  return undefined;
}

export function copyFileSync(src, dest) {
  return fileSystem.copyFileSync(src, dest);
}

// Node compat: returns Uint8Array (close enough for crypto-browserify / aws-sdk usage)
export function readFileSync(p) {
  const blob = fileSystem.tempFiles?.get(p) || null;
  if (!blob) {
    throw new Error(`fs.readFileSync: file not found: ${p}`);
  }

  // NOTE: This is synchronous in Node; in browsers we can't truly sync-read blobs.
  // For now we only support reading data that is already a Uint8Array/ArrayBuffer/string.
  // Most call sites will be migrated to async blob usage.
  if (blob instanceof Uint8Array) return blob;
  if (blob instanceof ArrayBuffer) return new Uint8Array(blob);
  if (typeof blob === 'string') return new TextEncoder().encode(blob);

  // If it's a Blob/File, we cannot read synchronously.
  throw new Error('fs.readFileSync is not supported for Blob/File in browser. Migrate call site to async.');
}

export function writeFileSync(p, data) {
  fileSystem.writeFileSync(p, data);
}

export function writeFile(p, data, encoding, cb) {
  // Signature variants: (path, data, cb) or (path, data, encoding, cb)
  const callback = typeof encoding === 'function' ? encoding : cb;
  fileSystem.writeFile(p, data)
    .then(() => callback && callback(null))
    .catch((err) => callback && callback(err));
}

export default {
  existsSync,
  statSync,
  readdirSync,
  unlinkSync,
  mkdirSync,
  copyFileSync,
  readFileSync,
  writeFileSync,
  writeFile,
};
